import PropTypes from 'prop-types';

import toLower from '../../../OC/PageBuilder/utilities/toLower';
import { formatBuyType } from '../format-buy-type';
import { ActionLink } from '../result-block-styled-components';

const Phone = ({ label, href, buyType, name, supplierId }) => (
  <ActionLink
    href={href}
    tabIndex={0}
    data-track="phone"
    data-track-buy-type={formatBuyType(buyType)}
    data-track-supplier-id={supplierId}
    data-track-supplier-name={toLower(name)}
  >
    {label}
  </ActionLink>
);

Phone.propTypes = {
  label: PropTypes.string.isRequired,
  href: PropTypes.string.isRequired,
  buyType: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  supplierId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

Phone.defaultProps = {
  supplierId: undefined,
};

export default Phone;
